import React, {
  Component,
  useContext,
  useState,
  useEffect,
  Fragment
} from "react";

import { currencies } from '../../data/currencies'

import { Tooltip } from "@material-ui/core";

import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import Paper from "@material-ui/core/Paper";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";

import IconAdd from "@material-ui/icons/AddBox";
import IconRem from "@material-ui/icons/IndeterminateCheckBox";

import Typography from "@material-ui/core/Typography";
import red from "@material-ui/core/colors/red";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import IconDelete from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { ProductContext } from "../../context";
import Colorer from "color";



import { Button } from "../uikit-b2c/uikit-b2c";

const defTheme = {
  id: "magenta",
  name: "Magenta Dark",
  colorText: "#D6E0E7",
  colorAccent: "#FF005B",
  colorAccentText: "#F6FAFF",
  colorBg: "#011627",

  borderRadius: 8,
  backgroundUrl:
    "https://res.cloudinary.com/maiik/image/upload/v1549624607/Xsolla/HomePage_Hero_Illustration_1440_oabqmk.jpg",

  cardWidth: 240,
  cardPadding: 24,

  boxShadow: "0 5px 12px 0px rgba(0,0,0,0.2)",
  transitionTime: "0.3s",
  transitionEasing: "ease-in-out",
  transition: "all 0.3s ease-in-out",
  transitionStyle: "0.3s ease-in-out",
  fontFamily:
    '"Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'
};

const ProductSlider = ({
  addToCart = () => {
    void 0;
  },
  preorder,
  id,
  product,
  name,
  order,
  cardType,
  initClass,
  image_url,
  title,
  currency,
  price,
  priceFull,
  discountPercent = null,
  description,
  is_favorite,
  in_cart,
  template,
  theme = defTheme,
  cardWidth = 300,
}) => {
  const [state, setState] = React.useState({
    expanded: false,
    cardShown: false
  });

  currency = currencies[currency]['symbol'];

  const valueFromContext = useContext(ProductContext);

  const [favorited, setFavorited] = React.useState(is_favorite);

  const getImage = () => {
    if (cardType === "virtualItems" || cardType === "currency") {
      return image_url;
    } else {
      if (cardType === "subscriptions") {
        let imgs = [
          "https://res.cloudinary.com/maiik/image/upload/e_hue:-68/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/e_hue:71/v1568958260/reward_01_zfoz16.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958293/reward_04_sea7a3.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568958304/reward_06_neq7kq.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_silver_lzaac0.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_bronze_pqse5y.png",
          "https://res.cloudinary.com/maiik/image/upload/v1568968595/payment_evseev_gold_cqdlw6.png"
        ];
        return imgs[order];
      } else {
        return "https://res.cloudinary.com/maiik/image/upload/v1568958260/reward_01_zfoz16.png";
      }
    }
  };

  useEffect(() => {
    if (is_favorite !== favorited) {
      setFavorited(is_favorite);
    }
  }, [is_favorite]);

  let [inCart, setInCart] = useState(0);

  useEffect(() => {
    if (in_cart !== inCart) {
      setInCart(in_cart);
    }
  }, [in_cart]);

  const handleExpandClick = () => {
    setState({
      ...state,
      expanded: !state.expanded
    });
  };

  const calcPrice = (prc, q) => {
    return prc * q;
  };

  const formatPrice = prc => {
    if (!prc) return 0;
    prc = prc.toString().search(".") !== -1 ? parseFloat(prc).toFixed(2) : prc;
    if (prc.toString().split(".").length === 1) prc = prc;
    if (prc.toString().split(".")[1] === '00') prc = prc[0];
    return prc;
  };

  const handleCartClick = (doWhat = "add") => {
  //  console.log("id = ", id);
    valueFromContext.setViValue(id, oneProduct => {
      if (doWhat === "add")
        oneProduct.in_cart = oneProduct.in_cart ? oneProduct.in_cart + 1 : 1;
      if (doWhat === "rem")
        oneProduct.in_cart = oneProduct.in_cart ? oneProduct.in_cart - 1 : 1;
      if (doWhat === "del") oneProduct.in_cart = 0;
      return oneProduct;
    });
  };

  const handleFavClick = event => {
    valueFromContext.setViValue(id, oneProduct => {
    //  console.log("id = ", id);
      oneProduct.is_favorite = oneProduct.is_favorite === 1 ? 0 : 1;
      return oneProduct;
    });
  };

  let time = null;
  useEffect(() => {
    if (!state.cardShown) {
      time = setTimeout(() => {
        setState({
          ...state,
          cardShown: true
        });
      }, order * 50);
    } else {
      setState({
        ...state,
        cardShown: true
      });
    }
    return () => {
      clearTimeout(time);
    };
  }, []);

  // const { classes } = props;
  // const { sku, name, image_url, description, amount, currency } = props;

  if (valueFromContext && valueFromContext["virtualItems"]) {
    return (
      <CssCardAppear className={!state.cardShown ? initClass : ""}>
        <CssCard
          cardType={cardType}
          cardWidth={cardWidth}
          theme={theme}
          template={template}
          image={getImage()}
        >
          <div className="s_slide"
            style={{
              height: `${cardWidth ? cardWidth*0.7 : 300}px`,
            }}
          >
            <div className="c_block c_slider">
              <div className="s_cont"
                style={{
                  width: '100%',
                  height: '100%',
                }}
              >
                <div className="s_c"
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <div className="s_c_50"
                    style={{
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <div className="s_pic"
                      style={{
                        width: `${cardWidth ? cardWidth/10+10 : 40}%`,
                      }}
                    >
                      <div className="s_pic_big"
                        style={{
                          width: '100%',
                          height: '100%',
                        }}
                      >
                        <div
                          className="c_pic c_pic--slider"
                          style={{
                            backgroundPosition: '100% 50%',
                            height: `${cardWidth ? cardWidth*0.7 : 300}px`,
                            width: '100%',
                            backgroundImage: `url(${image_url})`,
                            backgroundSize: 'contain',
                          }}
                        />
                      </div>
                    </div>
                    <div className="s_name"

                    style={{
                      width: `${cardWidth ? 100-cardWidth/10-10 : 60}%`,
                      height: `${cardWidth ? cardWidth*0.7 : 300}px`,
                    }}
                    >
                      <h1
                        style={{color: theme['colorText']}}
                      >{name}</h1>

                      <div className="s_name_h2">
                        <div>{description}</div>
                      </div>

                      <div
                      // style={{display: 'flex'}}
                          style={{padding: '0.4em 0 0.2em 0'}}
                      >
                        <div className="c_price_block c_price_block--slider">


                          <div className="c-txt0 c-txt0--slider">
                            <div className="c_price_new">
                              <div
                                className="c_txt1_price_new"
                                data-good="price_new"
                                style={{
                                  color: theme['colorAccent']
                                }}
                              >
                                <div className="text-block-2">{currency}&thinsp;{formatPrice(price)}</div>
                              </div>
                            </div>
                            <div className="c_txt1_price old">
                              {formatPrice(priceFull)}
                              <div className="price_old_strike" style={{borderTopColor:theme['colorAccent']}}/></div>
                            </div>
                          {preorder && <div className="c_txt1_price_count">
                            <div>Preorder price expires in 4 h 36 m</div>
                          </div>}
                        </div>


                        <div style={{
                          display: 'flex',
                          alignItems:'flex-start',
                          alignSelf: 'flex-start',
                          justifySelf: 'stretch',
                        }}>
                          <div style={{marginRight: 8}}>
                            <Button theme={theme}
                              style={{fontSize: '19px',}}
                            >Buy now</Button>
                          </div>
                          {/* <div className="but but_main but_slider">
                            <div>Buy Now</div>
                          </div> */}

                          {/* <div style={{marginRight: 8}}>
                            <Button theme={theme}
                              appearance="ghost"
                              style={{fontSize: '19px',}}
                            >Add to cart</Button>
                          </div> */}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {template === 'blurred' && <CssSliderBg
              className="s_bg"
              data-ix="swiper-bgzoom"
              style={{
                backgroundImage: `url(${image_url})`,
                height: `${cardWidth ? cardWidth*2 : 600}px`,
              }}
            >
              <CssSliderShadow theme={theme} className="s_bg_g" />
            </CssSliderBg>}


          </div>
        </CssCard>
      </CssCardAppear>
    );
  } else {
    return null;
  }
};

// Product.propTypes = {
//   classes: PropTypes.object.isRequired,
// };

const CssCartQs = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;




const CssSliderBg = styled.div`
  background-color: ${({theme}) => Colorer(theme.colorBg).blacken(0.3).desaturate(0.4).hex()};
  opacity: 1;
  z-index: -1;
  transition: opacity 0.8s ease-in-out 0s, opacity 800ms ease-in-out 0s;
`;

const CssSliderShadow = styled.div`

  background-image: linear-gradient(
    90deg,
    ${({theme}) => Colorer(theme.colorBg).blacken(0.3).desaturate(0.4).alpha(0.8).string()} 4%,
    ${({theme}) => Colorer(theme.colorBg).alpha(0.4).string()} 37%,
    ${({theme}) => Colorer(theme.colorBg).alpha(0.4).string()} 77%,
    ${({theme}) => Colorer(theme.colorBg).blacken(0.3).desaturate(0.4).alpha(0.8).string()} 97%);
`;


const CssCartQ = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bolder;
  min-width: 44px;
  font-size: 1.2em;
`;

const CssCardAppear = styled.div`
  /* position: relative; */
  height: 100%;
  /* transition: all ${props => props.order + "s"} ease-in-out; */
  transition: transform 350ms ease-out, opacity 150ms ease-out;
  &.initialFlow1 {
    opacity: 0;
    transform: translateY(20px) scale(1);
  };
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      width: 100%;
    `};
`;

// const CssCard = styled(Card)`
// Карточка не корзина
// Карточка корзина

const CssCard = styled.div`
  height: 100%;
  width: 100%;
  color: ${({ theme }) => (theme ? theme["colorText"] : "white")};
  display: flex;
  position: relative;
  height: ${({ cardWidth }) => (cardWidth ? cardWidth * 0.7 : 300)}px;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 1;
  flex-base: 50%;
  background: transparent;
  transition: box-shadow ${({ theme }) => !!theme ? theme["transitionStyle"] : "250ms ease-in-out"};
  ${({ cardWidth }) =>
    cardWidth < 200 &&
    css`
      font-size: 0.8em;
    `};


  & i {
    opacity: 0;
    transition: all 250ms ease-in-out;
    /* width: 100%;
    height: 100%; */
    position: absolute;
    top: -8px;
    bottom: -16px;
    left: -16px;
    right: -16px;
    z-index: -1;
    overflow: hidden;
    border-radius: ${({ theme }) => theme["borderRadius"]}px;
  }

  &:hover i {
    ${({ cardType, template }) =>
      cardType !== "cart" &&
      !template &&
      css`
         {
          opacity: 0.3;
        }
      `};

    ${({ cardType, template }) =>
      cardType !== "cart" &&
      template === "blurred" &&
      css`
         {
          opacity: 0.3;
        }
      `};
  }
`;

const CssCardBack = styled.i`



  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      /* overflow: hidden; */
      flex-direction: column;
      flex-shrink: 0;
      flex-grow: 1;
      flex-base: 50%;
      background: transparent;
      border-radius: ${({ theme }) => theme["borderRadius"]}}px;
      box-shadow: none;
      content: " ";
      opacity: 1;
      overflow: hidden;
    `};






    ${({ cardType, template }) =>
      cardType !== "cart" &&
      !template &&
      css`
         {
          box-shadow: ${({ theme }) => !!theme && theme["boxShadow"]};
          background-color: ${({ theme }) =>
            !!theme &&
            Colorer(theme["colorAccent"])
              .alpha(0.7)
              .string()};
        }
      `};

    ${({ cardType, template }) =>
      cardType !== "cart" &&
      template === "blurred" &&
      css`
         {
          background-image: url(${({ image }) => image});
          background-size: cover;
          filter: blur(20px);
          opacity: 0.4;
          box-shadow: ${({ theme }) => !!theme && theme["boxShadow"]};
          background-color: ${({ theme }) =>
            !!theme &&
            Colorer(theme["colorAccent"])
              .alpha(0.6)
              .string()};
        }
      `};


&::before {
  content: ' ';
  /* ${({ template, theme, image }) => {
    return (
      template === "blurred" &&
      css` */

      /* `
    );
  }} */
}


`;

const CssCardH1 = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bolder;
  padding-bottom: 0.2em;
`;

const CssDescEllipsis = styled.div`
  /* display: block;
  display: -webkit-box; */
  opacity: 0.8;
  width: 100%;
  font-size: 0.84em;
  margin: 0 auto;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ cardWidth }) =>
    cardWidth < 200 &&
    css`
      display: none;
    `};
`;

const CssCardContent = styled.div`
  min-height: 70px;
  width: 100%;
  overflow: hidden;
  flex-grow: 0;
  padding-bottom: 0 !important;
  margin-bottom: 12px;
  ${({ cardWidth }) =>
    cardWidth < 200 &&
    css`
      min-height: auto;
    `};
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      /* display: flex; */
      /* flex-direction: column; */
      /* flex-wrap: wrap; */
      align-items: flex-start;
      justify-content: center;
    `};
`;

const CssCardActions = styled.div`
  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-top: 1px solid
        ${({ theme }) =>
          Colorer(theme["colorText"])
            .alpha(0.1)
            .string()};
      padding: 8px 0 0 0;
      /* margin: 0px 16px 0 16px; */
    `}
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      /* padding: 16px 0; */
      width: 160px;
      display: grid;
      grid-template-columns: auto;
      grid-row-gap: 8px;
      place-content: start start;
      @media (max-width: 767px) {
        display: flex;
        width: 100%;
      }
    `}
`;

const CssCardActionsBorder = styled.div`
  border-top: 1px solid var(--mainDark);
  width: 100%;
`;

const CssCardMedia = styled.div`
  display: block;
  /* height: 0; */
  /* margin-top: 8px; */
  /* min-height: 120px; */
  flex-grow: 1;
  /* padding-top: 56.25%; */
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center 0;
  background-image: url(${({ image }) => image});
  min-width: 120px;
  height: ${({ cardWidth }) => cardWidth}px;
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      width: 120px;
      min-height: 120px;
      margin-right: 1em;
    `}
`;

const CssCard2 = styled.div`
  width: 100%;
  color: ${({ theme }) => (theme ? theme["colorText"] : "white")};
  opacity: 0.8;
  ${({ cardType }) =>
    cardType !== "cart" &&
    css`
      padding: 0 24px;
      @media (max-width: 767px) {
        padding: 0 0px;
      }
    `};
  ${({ cardType }) =>
    cardType === "cart" &&
    css`
      display: flex;
      width: 100%;
      @media (max-width: 767px) {
        display: block;
      }
    `};
`;

const CssTypographyPrice = styled.div`
  flex-grow: 1;
  flex-basis: 100%;
  font-size: 1.2em;
  /* color: ${({ theme }) => theme["colorAccent"]}; */
  font-weight: 600;
  flex-basis: auto;
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    flex-basis: 100%;
  }

  @media (max-width: 479px) {
  }
`;

const CssTypographypriceFull = styled.div`
  color: ${({ theme }) => theme["colorAccent"]};
  display: flex;
  flex-grow: 1;
  width: 100%;
  align-items: center;
  font-size: 0.8em;
  font-weight: 600;
`;

const CssTypographypriceFullNumber = styled.div`
  text-decoration: line-through;
`;

const CssTypographypriceFullPercent = styled.div`
  margin-right: 0.6em;
  font-size: 0.7em;
  background-color: ${({ theme }) => theme["colorAccent"]};
  color: ${({ theme }) => theme("colorAccentText")};
  display: flex;
  align-items: center;
  padding: 0em 0.4em 0.1em 0.4em;
  border-radius: 0.2em;
  text-transform: uppercase;
  /* height: 1.4em; */
`;

const CssTypographyPriceSm = styled.div`
  flex-grow: 1;
  font-size: 0.8em;
  /* color: ${({ theme }) => theme["colorAccent"]}; */
  /* font-weight: 600; */
  opacity: 0.3;
`;

export default ProductSlider;

/* flex-direction: ${(props) => {return (props.style === 'cart') ? 'column' : 'row'}} ; */
/* flexDirection: ${props.cardType} ? row : column; */
/* flexDirection: ${props => props.cardType ? 'row' : 'column'} */
